import { render, staticRenderFns } from "./WellnessSidebar.vue?vue&type=template&id=76826d42&scoped=true"
import script from "./WellnessSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WellnessSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./wellness-base.css?vue&type=style&index=0&id=76826d42&prod&scoped=true&lang=css&external"
import style1 from "./WellnessSidebar.vue?vue&type=style&index=1&id=76826d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76826d42",
  null
  
)

export default component.exports